import RobotsMetadata from './RobotsMetadata';

export default RobotsMetadata;
